import { render, staticRenderFns } from "./cookie-snackbar.vue?vue&type=template&id=394306f2&scoped=true&"
import script from "./cookie-snackbar.vue?vue&type=script&lang=ts&"
export * from "./cookie-snackbar.vue?vue&type=script&lang=ts&"
import style0 from "./cookie-snackbar.vue?vue&type=style&index=0&id=394306f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394306f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VSnackbar})
